import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default class Pipe extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Obstacle_Bottom);

    this.vX = -180;

    this.active = true;
    this.blinking = false;
    this.blinkWaiter = 0.5;
    this.setOrigin(0);
  }

  reset (istop, y, speed, alpha = 1) {
    this.active = true;
    this.setFrame(istop ? UIAssetKeys._Obstacle_Top : UIAssetKeys._Obstacle_Bottom).setOrigin(0);
    this.y = y;
    this.x = this.scene.scale.width;
    this.vX = -speed;
    this.alpha = alpha;
    this.blinking = false;
  }

  tick (dt) {
    this.x += dt * this.vX;
    if (this.blinking) {
      if (this.blinkWaiter <= 0) {
        this.alpha > 0.4 ? this.alpha = 0.4 : this.alpha = 0.8;
        this.blinkWaiter = 0.5;
      }
      else {
        this.blinkWaiter -= dt;
      }
    }
  }
}